export default "__VITE_ASSET__42071ae6__"